import * as Yup from 'yup'

export const BenefitsSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  image: Yup.string().required('Image is required'),
  discription: Yup.string().required('Description is required'),
  startDate: Yup.date().required('startDate is required'),
  endDate: Yup.date().required('endDate is required'),
})